import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-service-debug",
  templateUrl: "./service-debug.component.html",
  styleUrls: ["./service-debug.component.scss"],
})
export class ServiceDebugComponent {
}
